import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * /admin/** workspace-settings area: OWNER or ADMIN of the current workspace
 * (or the WizCode operator). Distinct from systemAdminGuard (operator-only).
 */
export const workspaceAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.loadUser().pipe(
    map(() => (auth.isWorkspaceAdmin() ? true : router.createUrlTree(['/dashboard']))),
  );
};
